import React from 'react';
export function Brand({
  className = ''
}: {
  className?: string;
}) {
  return <span className={`font-display text-2xl font-extrabold uppercase tracking-[0.5px] text-white ${className}`} data-id="element-26" data-mp="16c4vldu85fw9">
      Ministry Ready <span className="text-amber" data-id="element-27" data-mp="1bcj5l1fdyzwx">Hub.</span>
    </span>;
}